import React from "react";
import Button from "../common_components/Button";
import { useNavigate } from "react-router-dom";


function MissionCardButtonAndSubText({ mission, status, spotsRemaining, requirements, missionType, missionLocked, lockedReason }) {
    const navigate = useNavigate();

    const screenWidth = window.innerWidth;
    const isMobile = screenWidth < 840;

    function navigateToMission(event) {
        // Stop propagation of the click event
        event.stopPropagation();
        navigate(`/missions/${mission.id}`);
    }

    if (status == "none" && !missionLocked) {
        return (
            <>
                <Button
                    color="primary"
                    size="medium"
                    fullWidth={isMobile}
                    setWidth={!isMobile ? "150px" : null}
                    onClick={navigateToMission}>
                    {"Apply"}
                </Button>
                <div className="apply-button-extra-description-dim body-tiny">
                    {spotsRemaining + " spots remaining"}
                </div>
            </>
        )
    } else if (status == "none" && missionLocked) {
        return (
            <>
                <Button
                    color="primary"
                    size="medium"
                    fullWidth={isMobile}
                    setWidth={!isMobile ? "150px" : null}
                    onClick={navigateToMission}>
                    {"Apply"}
                </Button>
                <div className="apply-button-extra-description-white body-tiny">
                    {lockedReason == "profile" ? "Additional profile information required" : "Additional wallet activity required"}
                </div>
            </>
        )
    } else if (status == "in_review") {
        return (
            <>
                <Button
                    color="primary-outline"
                    size="medium"
                    fullWidth={isMobile}
                    setWidth={!isMobile ? "150px" : null}
                    onClick={navigateToMission}>
                    Applied
                </Button>
                <div className="apply-button-extra-description-white body-tiny">
                    Researcher is reviewing your profile
                </div>
            </>
        )
    } else if (status == "prescreen") {
        return (
            <>
                <Button
                    color="primary"
                    size="medium"
                    fullWidth={isMobile}
                    setWidth={!isMobile ? "150px" : null}
                    onClick={navigateToMission}>
                    Take screener
                </Button>
                <div className="apply-button-extra-description-white body-tiny">
                    As a next step, answer screener questions
                </div>
            </>
        )

    } else if (status == "applied" && missionType == "interview") {
        return (
            <>
                <Button
                    color="primary"
                    size="medium"
                    fullWidth={isMobile}
                    setWidth={!isMobile ? "150px" : null}
                    onClick={navigateToMission}>
                    Schedule
                </Button>
                <div className="apply-button-extra-description-white body-tiny">
                    As a next step, schedule your interview
                </div>
            </>
        )
    } else if (status == "applied" && missionType == "survey") {
        return (
            <>
                <Button
                    color="primary"
                    size="medium"
                    fullWidth={isMobile}
                    setWidth={!isMobile ? "150px" : null}
                    onClick={navigateToMission}>
                    Take survey
                </Button>
                <div className="apply-button-extra-description-white body-tiny">
                    Complete the survey to earn your reward
                </div>
            </>
        )
    } else if (status == "scheduled") {
        return (
            <>
                <Button
                    color="primary-outline"
                    size="medium"
                    fullWidth={isMobile}
                    setWidth={!isMobile ? "150px" : null}
                    onClick={navigateToMission}>
                    Scheduled
                </Button>
                <div className="apply-button-extra-description-white body-tiny">
                    Your interview is coming up!
                </div>
            </>
        )
    } else if (status == "completed") {
        return (
            <>
                <Button
                    color="green-outline"
                    size="medium"
                    fullWidth={isMobile}
                    setWidth={!isMobile ? "150px" : null}
                    onClick={navigateToMission}>
                    Completed
                </Button>
            </>
        )
    } else if (status == "rejected") {
        return (
            <>
                <Button
                    color="red-outline"
                    size="medium"
                    fullWidth={isMobile}
                    setWidth={!isMobile ? "150px" : null}
                    onClick={navigateToMission}>
                    Rejected
                </Button>
            </>
        )
    }
}

export default MissionCardButtonAndSubText;